const faqTopQuestions = [
  {
    id: 0,
    name: 'comment-contacter-tictactrip',
    title: 'Comment nous contacter ?',
  },
  {
    id: 1,
    name: 'intermodalite-multimodalite-transports-combines',
    title: 'Lexique : Intermodalité, multimodalité et transports combinés',
  },
  {
    id: 2,
    name: 'compagnies-transport-annulation-remboursement-coronavirus',
    title: 'Compagnies de transport : annulations et remboursement COVID-19',
  },
  {
    id: 3,
    name: 'bons-plans-sncf',
    title: 'Les bons plans SNCF',
  },
];

export default faqTopQuestions;
